export default __webpack_public_path__ + "static/media/image10.6b673f01.png";